import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import {handleApiError} from '../../shared/services';
import {loadGrades} from '../../shared/actions';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import {TextInput} from '../../shared/components';
import toastr from 'toastr';
import {withRouter} from 'react-router';
import {List, Map} from 'immutable';

import {
  loadTitles,
  resetUserProfileForm,
  setUserProfileForm,
  submitUserProfileForm,
} from '../actions';

import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import React, {Component, PropTypes} from 'react';

class UserProfileMobileForm extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  componentDidMount() {
    const {router} = this.props;

    this.props.loadTitles()
      .catch(error => handleApiError(error, router, 'An unexpected error occurred while attempting to load the titles.', 'Error'));

    this.props.loadGrades()
      .catch(error => handleApiError(error, router, 'An unexpected error occurred while attempting to load the grades.', 'Error'));
  }

  handleFieldChange(event) {
    const {name, value} = event.target;
    this.props.onFieldChange(name, value);
  }

  handleGradesSelectChange(event, index, values) {
    this.props.onFieldChange('gradeIds', values);
  }

  handleTitleSelectChange(event, index, values) {
    this.props.onFieldChange('title', values);
  }

  handleSubmitClick(event) {
    event.preventDefault();

    const {handleSubmit, model, router, userId, redirectOnSuccess} = this.props;

    handleSubmit(userId, model)
      .then(() => {
        toastr.success('Success.', 'Your profile has been updated', {timeout: 10000, allowHtml: true});
        if (redirectOnSuccess) {
          router.push('/');
        }
        window.location.reload();
      })
      .catch(error => {
        handleApiError(error, router, 'An error occurred while attempting to update your profile.', 'Error');
      });
  }

  titleMenuItems() {
    const {titles} = this.props;

    return titles.map(title =>
      <MenuItem
        key={title.get('id')}
        value={title.get('key')}
        primaryText={title.get('text')} />
    );
  }

  gradeMenuItems(values) {
    const {grades} = this.props;

    return grades.map(grade =>
      <MenuItem
        key={grade.get('id')}
        insetChildren
        checked={values && values.includes(grade.get('id'))}
        value={grade.get('id')}
        primaryText={grade.get('long')} />
    );
  }

  render() {
    const {submitting, model, submitText} = this.props;

    const submitDisabled = submitting ||
      !model.get('lastName') ||
      !model.get('firstName') ||
      !model.get('username') ||
      !model.get('title') ||
      !model.get('imageSet');

    return (
      <div>
        <form onSubmit={this.handleSubmitClick} className="user-profile-mobile-form">
          <div><small>*Required</small></div>
          <div disabled={submitting}>
            <div className="input-container">
              <TextInput
                className="field-input"
                id="firstName"
                value={model.get('firstName')}
                floatingLabelText="First Name*"
                onChange={this.handleFieldChange} />
              <TextInput
                className="field-input"
                id="lastName"
                value={model.get('lastName')}
                floatingLabelText="Last Name*"
                onChange={this.handleFieldChange} />
              <TextInput
                className="field-input"
                id="username"
                value={model.get('username')}
                floatingLabelText="Username*"
                onChange={this.handleFieldChange} />
              <SelectField
                className="field-input select-field"
                id="title"
                onChange={this.handleTitleSelectChange}
                value={model.get('title')}
                hintText="Title*">
                {this.titleMenuItems()}
              </SelectField>
              {
                model.get('title') === 'teacher'
                ? <SelectField
                    className="field-input select-field"
                    multiple
                    hintText="Grade(s) taught"
                    value={model.get('gradeIds')}
                    onChange={this.handleGradesSelectChange} >
                  {this.gradeMenuItems(model.get('gradeIds'))}
                </SelectField>
                : <div />
              }
            </div>
            <label className="icon-label">Icon Set*</label>
            <RadioButtonGroup
              name="imageSet"
              onChange={this.handleFieldChange}
              valueSelected={model.get('imageSet')}>
              <RadioButton value="middle_school" label="Middle School" />
              <RadioButton value="grade_school" label="Grade School" />
            </RadioButtonGroup>
          </div>
          <div className="submit-button-container">
            <RaisedButton
              style={{fontSize: 14, fontWeight: 700}}
              className="raised-button--rounded"
              type="submit"
              secondary
              disabled={submitDisabled}>{submitText}</RaisedButton>
          </div>
        </form>
      </div>
    );
  }
}

UserProfileMobileForm.defaultProps = {
  redirectOnSuccess: true,
  submitText: 'Let\'s Go',
};

UserProfileMobileForm.propTypes = {
  grades: PropTypes.instanceOf(List).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loadGrades: PropTypes.func.isRequired,
  loadTitles: PropTypes.func.isRequired,
  model: PropTypes.instanceOf(Map).isRequired,
  onFieldChange: PropTypes.func.isRequired,
  redirectOnSuccess: PropTypes.bool,
  router: PropTypes.object.isRequired,
  submitText: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  titles: PropTypes.instanceOf(List).isRequired,
  userId: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  const {setUserProfile} = state.features.userProfile.pages;

  return {
    grades: setUserProfile.get('grades'),
    model: setUserProfile.get('model'),
    submitting: setUserProfile.get('submitting'),
    titles: setUserProfile.get('titles'),
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    handleSubmit: submitUserProfileForm,
    loadGrades,
    loadTitles,
    onFieldChange: setUserProfileForm,
    resetUserProfileForm,
  }
)(UserProfileMobileForm));



// WEBPACK FOOTER //
// ./app/features/userProfile/components/UserProfileMobileForm.js